import { useNavigate, useLocation } from 'react-router-dom';
import AuthForm from '../components/AuthForm';
import { ROUTES } from '@app/router/routes';

const LoginPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const redirectTo = location.state?.redirectTo ?? ROUTES.HOME;

    return (
        <div className="flex items-start justify-center bg-[var(--color-background)] pt-10 pb-6 md:pt-16 md:pb-16 px-4 md:px-0">
            <div className="w-full max-w-[430px] bg-[var(--color-surface)] relative rounded-[18px] shadow-lg h-fit">
                <div className="absolute inset-0 bg-[var(--color-background)] -z-10 bg-opacity-50"></div>
                <AuthForm
                    mode="login"
                    onSuccess={() => navigate(redirectTo, { replace: true })}
                    onSwitchMode={() => navigate(ROUTES.REGISTER, { state: { redirectTo } })}
                />
            </div>
        </div>
    );
};

export default LoginPage;
